import React, {useEffect} from 'react';
import Container from "@mui/material/Container";
import {useNavigate, useParams} from "react-router-dom";
import Box from "@mui/material/Box";
import {CircularProgress} from "@mui/material";
import {apiSlice, useProcessRuidMutation} from "../slices/apiSlice";
import {AUTHENTICATED, login, logout, setToken} from "../slices/sessionSlice";
import {useDispatch, useSelector} from "react-redux";

const RuidHandler = () => {
    const {ruid} = useParams()
    const session = useSelector(state => state.session)
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const [processRuid, processRuidResult] =
        useProcessRuidMutation()

    useEffect(() => {
        processRuid(ruid)
    }, []);

    useEffect(() => {
        if (processRuidResult.isSuccess) {
            if (processRuidResult.data.status === 'ok') {
                const data = processRuidResult.data

                if (session.status === AUTHENTICATED) {
                    dispatch(logout())
                }

                dispatch(apiSlice.util.resetApiState());
                dispatch(setToken(data))
                dispatch(login(data))

                if (data.action==='resetPassword') {
                    navigate(`/resetPassword/${data.uuid}`)
                }
                else {
                    navigate(data.uri)
                }
            }
            else {
                console.log("*** Error while processing link")
                console.log(processRuidResult.data.error)
            }
        }
        else {
            console.log("*** Error while processing link")
            console.log(processRuidResult.error)
        }
    }, [processRuidResult]);


    return (
        <Container>
            <Box my={'45vh'}>
                <CircularProgress/>
            </Box>
        </Container>
    );
};

export default RuidHandler;